<template>
  <div>
    <v-card-text class="pt-0 mt-0">
      <v-chip class="mt-4" label color="transparent" text-color="black">
        <h3>
          Seleccionar
          {{ resolveTitle }}
        </h3>
      </v-chip>

      <v-row dense class="mt-4" v-if="obrasSociales.length > 0">
        <v-col cols="12" md="3" sm="4">
          <v-select
            :items="obrasSociales"
            item-text="nombre"
            item-value="idObraSocial"
            prepend-icon="mdi-card-account-details"
            v-model="obraSocial"
            :label="resolveLabel"
            dense
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="idInstitucion === 195">
          <v-text-field
            v-model="nroAfiliado"
            prepend-icon="mdi-account"
            label="Nro. Afiliado *"
            maxlength="100"
            :rules="requiredRules"
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="tiposTurno.length">
          <v-select
            :items="tiposTurno"
            v-model="tipoDeTurno"
            item-text="nombreTipoTurno"
            item-value="idTipoTurno"
            label="Tipo de Turno *"
            dense
            prepend-icon="mdi-account"
            return-object
            no-data-text="No hay Tipos de Turno configurados"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense class="mt-4" v-if="obrasSociales.length == 0">
        <v-col cols="12" md="3" sm="4">
          <v-alert color="blue" dark outlined class="mb-0 mt-2"
            >No hay Obras Sociales configuradas para el portal, comuníquese
            directamente con la institución</v-alert
          >
        </v-col>
      </v-row>
      <v-row v-if="observaciones && muestraObservaciones">
        <v-col cols="12">
          <v-alert color="purple" dark outlined>{{ observaciones }}</v-alert>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="2">
          <v-btn
            :disabled="
              obrasSociales.length === 0 ||
              (idInstitucion === 195 && !nroAfiliado)
            "
            small
            class="success mt-2"
            @click.stop="seleccionar"
            >Continuar</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>
<script>
export default {
  props: ["obrasSociales", "idInstitucion", "tiposTurno"],
  watch: {
    obrasSociales: function (val) {
      if (val.length > 0) {
        this.obraSocial = val[0].idObraSocial;
        this.observaciones = val[0].observaciones;
        this.muestraObservaciones = val[0].muestraObservacionesEnWeb;
      }
    },
    tiposTurno: {
      handler(val) {
        if (val.length > 0) {
          this.tipoDeTurno = val.find((tt) => tt.porDefecto) ?? val[0];
        }
      },
    },
    obraSocial: {
      handler(val) {
        if (val) {
          this.observaciones = this.obrasSociales.find(
            (os) => os.idObraSocial === val
          ).observaciones;
          this.muestraObservaciones = this.obrasSociales.find(
            (os) => os.idObraSocial === val
          ).muestraObservacionesEnWeb;
        }
      },
    },
  },
  data: (vm) => ({
    obraSocial: null,
    nroAfiliado: "",
    tipoDeTurno: null,
    observaciones: "",
    muestraObservaciones: false,
  }),
  computed: {
    resolveLabel() {
      if ([454].includes(this.idInstitucion)) {
        return "Modalidad de Atención *";
      }
      return this.$store.state.esEmpresa
        ? "Sede *"
        : "Obras Sociales Vigentes *";
    },
    resolveTitle() {
      let title = "";
      if ([454].includes(this.idInstitucion)) {
        title = "Modalidad de Atención";
      }
      title = this.$store.state.esEmpresa ? "Sede" : "Obra Social";

      if (this.tiposTurno.length) {
        title += " y Tipo de Turno";
      }

      return title;
    },
  },
  methods: {
    seleccionar() {
      this.$emit("obraSocialSeleccionada", {
        obraSocial: this.obraSocial,
        nroAfiliado: this.nroAfiliado,
        tipoDeTurno: this.tipoDeTurno,
      });
    },
  },
  mounted() {
    if (this.obrasSociales.length > 0) {
      this.obraSocial = this.obrasSociales[0].idObraSocial;
    }

    if (this.tiposTurno.length > 0) {
      this.tipoDeTurno = this.tiposTurno.find((tt) => tt.porDefecto);
    }
  },
};
</script>
